import Layout from '../../internal/Layout.vue'
import SupplierPage from './suppliers.vue'
import ImportSuppliersPage from './components/import.vue'

const SupplierRoutes = {
  component: Layout,
  children: [
    {
      name: 'supplier',
      path: '/',
      component: SupplierPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'supplier-import',
      path: 'import',
      component: ImportSuppliersPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default SupplierRoutes
